import http from '../http';
import {api} from '../api';
import {
  AnalysisByDateData,
  AnalysisDetailsItemType,
  GetAnalysisByDateBody,
} from '../../interfaces/api/analysis';
import {store} from '../../redux/store';
import {HttpResponse} from '../../interfaces/api/http';

export const analysis = {
  getById: (id: number): Promise<HttpResponse<AnalysisDetailsItemType>> =>
    new Promise((resolve, reject) => {
      const url = `${api.analysis.getById}${id}`;
      http
        .get<AnalysisDetailsItemType>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  getByDate: ({
    tabId,
    dateFrom,
    dateTo,
    page,
    filters,
  }: GetAnalysisByDateBody): Promise<HttpResponse<AnalysisByDateData>> =>
    new Promise((resolve, reject) => {
      const {specialty_id} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (!tabId || !specialty_id) {
        throw new Error('tab id and subspecialty id are required');
      }
      params.append('tab_id', tabId.toString());
      params.append('specialty_id', specialty_id.toString());
      Object.keys(filters || {}).forEach(key => {
        if (
          filters[key] &&
          (key === 'specialty_id' ||
            key === 'type_of_study_id' ||
            key === 'resource_id')
        ) {
          params.append(key, String(filters[key]));
        }
      });
      params.append('dateFrom', dateFrom.toString());
      if (dateTo) {
        params.append('dateTo', dateTo.toString());
      }

      if (page) {
        params.append('page', page.toString());
        params.append('pageSize', '10');
      }
      const url = `${api.analysis.getByDateRange}?${params.toString()}`;
      http
        .get<AnalysisByDateData>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
